import React, { useState, useEffect } from 'react';
import {
  Table, Thead, Tbody, Tr, Th, Td, Button,
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  useDisclosure, Badge, Flex, Spinner, IconButton,
  Box
} from '@chakra-ui/react';
import { AddIcon, TriangleDownIcon, TriangleUpIcon } from '@chakra-ui/icons';
import RegistroMultaObstruccion from '../Ventanas/RegistroMultaObstruccion';


interface MultaObs {
  Id: number;
  UsuarioId: number;
  Folio: string | null;
  
}


const TablaMultaObstruccion: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [modoModal, setModoModal] = useState<'view' | 'edit' | 'new'>('view');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [sortConfig, setSortConfig] = useState<{ key: keyof MultaObs; direction: 'asc' | 'desc' } | null>(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/obras/multa-obstruccion`)
      .then((res) => res.json())
      .then(setData)
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  const handleOpenModal = (item: any, modo: 'view' | 'edit') => {
    setSelectedItem(item);
    setModoModal(modo);
    onOpen();
  };

  const handleNew = () => {
    setSelectedItem(null);
    setModoModal('new');
    onOpen();
  };

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const requestSort = (key: keyof MultaObs) => {
    let direction: 'asc' | 'desc' = 'asc';
    if (sortConfig?.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };
  const getSortIcon = (key: keyof MultaObs) => {
    if (!sortConfig || sortConfig.key !== key) return null;
    return sortConfig.direction === 'asc' ? <TriangleUpIcon ml={1} /> : <TriangleDownIcon ml={1} />;
  };

  if (loading) return <Spinner mt={4} />;

  return (
    <Box overflowX="auto" borderRadius="md" boxShadow="md" bg="white" p={4}>
      <Table variant="simple" size="sm">
      <Thead bg="#5b182b">
      <Tr>
      <Th color="white" cursor="pointer" onClick={() => requestSort('Id')}>Folio {getSortIcon('Id')}</Th>
      <Th color="white" >Superficie</Th>
            <Th color="white" >Costo</Th>
            <Th color="white" >Dirección</Th>
            <Th color="white" >Inspector</Th>
            <Th color="white" >Acciones</Th>
          </Tr>
        </Thead>
        <Tbody>
          {currentItems.map((item) => (
            <Tr key={item.id}>
              <Td>{item.id}</Td>
              <Td>{item.area} m²</Td>
              <Td>${item.costo}</Td>
              <Td>{item.direccion}</Td>
              <Td>{item.inspector || '—'}</Td>
              <Td>
                <Button size="sm" onClick={() => handleOpenModal(item, 'view')}>Ver</Button>{' '}
                <Button size="sm" onClick={() => handleOpenModal(item, 'edit')}>Editar</Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      <Flex mt={4} justify="center" gap={2}>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button
            key={i + 1}
            size="sm"
            colorScheme={currentPage === i + 1 ? 'blue' : 'gray'}
            onClick={() => paginate(i + 1)}
          >
            {i + 1}
          </Button>
        ))}
      </Flex>

      <IconButton
        icon={<AddIcon />}
        aria-label="Agregar nueva multa"
        position="fixed"
        bottom="24px"
        right="24px"
        colorScheme="red"
        borderRadius="full"
        size="lg"
        boxShadow="lg"
        zIndex={10} 
        onClick={handleNew}
      />

      <Modal isOpen={isOpen} onClose={onClose} size="5xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {modoModal === 'view'
              ? 'Ver multa'
              : modoModal === 'edit'
              ? 'Editar multa'
              : 'Nueva multa'}
          </ModalHeader>
          <ModalBody>
            <RegistroMultaObstruccion
              modo={modoModal}
              data={modoModal === 'new' ? undefined : selectedItem}
            />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={onClose}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TablaMultaObstruccion;
